
import { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { QrCode, AlertCircle } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import QRCode from 'react-qr-code';
import { downloadQRCode } from '@/utils/qrCodeDownload';

interface QRCodeShareProps {
  referralUrl: string | null;
}

export function QRCodeShare({ referralUrl }: QRCodeShareProps) {
  const { toast } = useToast();
  const qrCodeRef = useRef<HTMLDivElement>(null);

  const handleDownloadQR = async () => {
    if (!referralUrl) {
      toast({
        title: "No QR code available",
        description: "Please wait while we generate your referral QR code.",
        variant: "destructive"
      });
      return;
    }

    const svg = qrCodeRef.current?.querySelector("svg");

    if (!svg) {
      toast({
        title: "Could not generate QR code image",
        description: "The QR code element was not found.",
        variant: "destructive"
      });
      return;
    }

    try {
      await downloadQRCode(svg as unknown as SVGElement, 'the-mat-monster-referral');

      toast({
        title: "QR code downloaded",
        description: "Your referral QR code has been saved successfully.",
      });
    } catch (error) {
      console.error("Error generating QR code image:", error);
      toast({
        title: "Download failed",
        description: "Could not generate the QR code image. Please try again.",
        variant: "destructive"
      });
    }
  };
  
  return (
    <div className="space-y-4 flex flex-col items-center">
      <p className="text-sm">Share this QR code:</p>
      {referralUrl ? (
        <div ref={qrCodeRef} className="bg-white p-4 rounded-md">
          <QRCode value={referralUrl} size={150} />
        </div>
      ) : (
        <div className="bg-muted p-4 rounded-md flex items-center justify-center h-[150px] w-[150px]">
          <AlertCircle className="h-10 w-10 text-muted-foreground" />
        </div>
      )}
      <Button 
        onClick={handleDownloadQR}
        disabled={!referralUrl}
      >
        <QrCode className="h-4 w-4 mr-2" />
        Download QR Code
      </Button>
    </div>
  );
}
